<template>
    <div class="guest-banner">
        <div class="banner-content">
            <span class="banner-message">
                <svg class="info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="16" x2="12" y2="12"/>
                    <line x1="12" y1="8" x2="12.01" y2="8"/>
                </svg>
                {{ message }}
            </span>
            <div class="banner-actions">
                <router-link to="/register" class="register-btn">Register</router-link>
                <router-link to="/login" class="login-link">Log in</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GuestBanner',
    props: {
        message: {
            type: String,
            default: 'Guest - your progress won\'t be saved'
        }
    }
};
</script>

<style scoped>
.guest-banner {
    background: rgba(var(--accent-rgb), 0.1);
    border-bottom: 1px solid rgba(var(--accent-rgb), 0.3);
    padding: 12px 20px;
}

.banner-content {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.banner-message {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--text-secondary);
    font-size: 14px;
    font-weight: 500;
}

.info-icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    opacity: 0.8;
}

.banner-actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.register-btn {
    padding: 8px 16px;
    background: var(--accent);
    color: var(--bg-primary);
    text-decoration: none;
    font-size: 13px;
    font-weight: 600;
    transition: transform 0.2s, opacity 0.2s;
}

.register-btn:hover {
    transform: translateY(-1px);
    opacity: 0.9;
}

.login-link {
    color: var(--text-secondary);
    text-decoration: none;
    font-size: 13px;
    font-weight: 500;
    opacity: 0.9;
    transition: opacity 0.2s;
}

.login-link:hover {
    opacity: 1;
}

@media (max-width: 600px) {
    .banner-content {
        flex-direction: column;
        text-align: center;
        gap: 12px;
    }

    .banner-message {
        justify-content: center;
    }
}
</style>
